import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, Search, Settings } from 'lucide-react';
import { useFEMachines } from '@/hooks/useFEMachines';
import { MachineModal } from '@/components/flexe/MachineModal';
import { MachinesTable } from '@/components/flexe/MachinesTable';
import { FEMachine } from '@/types/flexe';

export default function CRMFlexEMachines() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedMachine, setSelectedMachine] = useState<FEMachine | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const { machines, isLoading, deleteMachine, isDeleting } = useFEMachines();

  const handleEdit = (machine: FEMachine) => {
    setSelectedMachine(machine);
    setIsModalOpen(true);
  };

  const handleAdd = () => {
    setSelectedMachine(null);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedMachine(null);
  };

  const filteredMachines = machines.filter(machine => 
    machine.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="container mx-auto p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Machine Catalogus</h1>
          <p className="text-muted-foreground mt-2">
            Beheer machines voor scenario simulaties
          </p>
        </div>
        <Button onClick={handleAdd}>
          <Plus className="w-4 h-4 mr-2" />
          Nieuwe Machine
        </Button>
      </div>

      {/* Search */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
        <Input
          placeholder="Zoek machines..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10"
        />
      </div>

      {/* Content */}
      {isLoading ? (
        <div className="text-center py-12">
          <p className="text-muted-foreground">Machines laden...</p>
        </div>
      ) : filteredMachines.length === 0 ? (
        <div className="text-center py-12 border-2 border-dashed rounded-lg">
          <Settings className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground mb-4">Geen machines gevonden</p>
          <Button onClick={handleAdd}>
            <Plus className="w-4 h-4 mr-2" />
            Voeg je eerste machine toe
          </Button>
        </div>
      ) : (
        <MachinesTable
          machines={filteredMachines}
          searchQuery={searchQuery}
          onEdit={handleEdit}
          onDelete={deleteMachine}
          isDeleting={isDeleting}
        />
      )}

      {/* Modal */}
      <MachineModal
        open={isModalOpen}
        onClose={handleClose}
        machine={selectedMachine}
      />
    </div>
  );
}
